import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as commonData from "../Common";
import {
  ApiCellRenderer,
  CheckboxCellRenderer,
  DateCellrenderer,
  PeopleCellRenderer,
  SelectCellRenderer,
  StatusCellRenderer,
  MainCellRenderer,
  CategoryCellRenderer,
  BoardCellRenderer,
} from "../components/Board/cellrenderer";
import CustomFilter from "../components/Board/cellrenderer/CustomFilter";
import CustomerCellRenderer from "./Board/cellrenderer/CustomerCellRenderer";
import CountStatusBarComponent from "./Board/CountStatusBarComponent";
import DownArrowSvg from "./UI/svg/DownArrowSvg";
import PriorityCellRenderer from "./Board/cellrenderer/PriorityCellRenderer";
import AssignToEdit from "./AssignToEdit";
import PriorityEditor from "./PriorityEditor";
import CategoryCellEditor from "./CategoryCellEditor";
import ApiCellEditor from "./ApiCellEditor";
import StatusCellEditor from "./StatusCellEditor";
import SelectCellEditor from "./SelectCellEditor";
import DateTimeDisplay from "../utils/TimeZoneDisplay";
import EffortCellRenderer from "./Board/cellrenderer/EffortCellRenderer";
import ProjectCellRenderer from "./Board/cellrenderer/ProjectCellRenderer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiSelectCellRenderer from "./Board/cellrenderer/MultiSelectCellRenderer";
import UrlEditorParams from "./Board/cellrenderer/UrlEditorParams";
import EffortCellEditor from "./Board/cellrenderer/EffortCellEditor";
import { convertTime } from "../utils/convertTime";
import ToggleCellEditor from "./ToggleCellEditor";

const AgGridComponent = (props) => {
  const param = useParams();
  const gridRef = useRef(null);
  const headerCheckbox = useRef(null);
  const statedata = useSelector((state) => state);
  let nameclick = useRef(null);
  let menuButton = useRef(null);
  const [state, setState] = useState({
    gridApi: null,
    columnApi: null,
    apiapi: null,
    perPageSizeChange: "",
    users: {},
    conditions: props.conditions,
    checkFunctionCalled: false,
    info: { ...commonData.getCommonData() },
    paginationDefaultValue: props.pagination_default_value,
    columnDefs: [],
    params: {},
    newdatacheck: [],
    selectedrowsdata: [],
    statusBar: {
      statusPanels: [
        {
          statusPanel: CountStatusBarComponent,
          key: "CountStatusBarComponent",
          statusPanelParams: {
            aggFuncs: props.callStatusPanel,
            fullScreen: props.externalWindowViewCustomModal,
            closeFullScreen: props.closeCustomModalHandler,
            isFullScreenView: props.isFullScreenView,
            showIconFullScreen: props.showIconFullScreen,
          },
        },
      ],
    },
    defaultColDef: {
      resizable: true,
      wrapText: true,
      autoHeight: true,
      cellClass: (params) => {
        if (params.colDef?.is_editable) {
          return "allowed-editable";
        } else {
          return "not-editable";
        }
      },
      suppressSizeToFit: false,
      suppressHorizontalScroll: true,
      scrollbarWidth: 0,
      menuTabs: ["filterMenuTab"],
      editable: true,
      suppressMenu: true,
      enableValue: true,
      enableRowGroup: true,
      width: 275,
      cellRenderer: MainCellRenderer,
      cellRendererParams: {
        child: props.child,
        childFunc: props.childFunc,
      },
    },
  });
  const getValidDate = (date) => {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate) && parsedDate.toString() !== "invalid date";
  };
  const checkIsCompleteHandler = async (evt, params) => {
    params.data.completed = evt.target.checked;

    setState((sta) => {
      return {
        ...sta,
        params: params,
        checkFunctionCalled: true,
      };
    });
    props.checkIsCompleteHandler(evt, params);
  };
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        users: props.users,
      };
    });
  }, [props.users]);

  let customerHeaderCall = useCallback(
    (params) => {
      let sort = null;
      let menu = null;
      if (params.column.colDef.is_filter) {
        menu = (
          <div
            ref={(menuButton) => {
              menuButton = menuButton;
            }}
            className="customHeaderMenuButton"
            onClick={() => onMenuClicked(params, menuButton)}
          >
            {params.column.colDef.attribute_type === "text" ||
            params.column.colDef.attribute_type === "textarea" ||
            params.column.colDef.attribute_type === "customer_tattle_uuid" ||
            params.column.colDef.attribute_type === "url" ||
            params.column.colDef.attribute_type === "email" ||
            params.column.colDef.attribute_type === "tel" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="16"
                // fill="rgb(21, 156, 247)"
                viewBox="0 0 50 50"
                height="16"
                className="filter-svg"
              >
                <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"></path>
              </svg>
            ) : (
              <svg
                width="16"
                height="44"
                viewBox="0 0 16 44"
                xmlns="http://www.w3.org/2000/svg"
                className="filter-svg"
              >
                <path
                  d="M1 18H15"
                  stroke="#5C5F62"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.5 22H12.5"
                  stroke="#5C5F62"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.5 26H9.5"
                  stroke="#5C5F62"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
        );
      }

      if (params?.enableSorting) {
        sort = (
          <div className="arrow-chevron">
            <div
              className="sorting-custom"
              onClick={() => props.onSortRequested(params)}
            >
              <div>
                <span
                  className={`customSortDownLabel sorttt ${
                    params.column.sort === "asc" ? "notdisaplay" : ""
                  } desc${params.column.sort === "desc" ? "descactive" : ""}`}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11.0833V2.91663"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2.9165 6.99996L6.99984 2.91663L11.0832 6.99996"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span
                  className={`customSortUpLabel sorttt asc${
                    params.column.sort === "asc" ? "ascactive" : ""
                  }`}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 2.91671L7 11.0834"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.0835 7.00004L7.00016 11.0834L2.91683 7.00004"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        );
      }
      return (
        <div className="customHeaderLabel" ref={(el) => (nameclick = el)}>
          {params.column.colId === "customer_tattle_uuid" ||
          params.column.colId === "checkiq" ? (
            <div className="custom-header-checkbox">
              {" "}
              {params.displayName} {sort}
            </div>
          ) : (
            <div className="custom-header-checkbox">
              {!props.child && (
                <span
                  className="hidden_columns"
                  onClick={() => props.onCheckBoxChange(params)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                    width={15}
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                </span>
              )}
              &nbsp;
              <span
                className="attrRename"
                onClick={() =>
                  !props.child && props.is_admin == 1
                    ? props?.renameAttribute(params)
                    : null
                }
              >
                {params.displayName.charAt(0).toUpperCase() +
                  params.displayName.slice(1)}
                {props.is_admin == 1 && !props.removeDropIcon ? (
                  <DownArrowSvg />
                ) : null}
              </span>
              {sort}
            </div>
          )}
          <div className="sort-menu"> {menu}</div>
        </div>
      );
    },
    [state.columnDefs, props.is_admin, state.users]
  );
  const checkIsCellEditable = useCallback(
    (para) => {
      const { data } = para;
      if (data.hasOwnProperty("assign_to")) {
        let getData = state.users[data.assign_to];
        return getData.is_active ? true : false;
      }
      return false;
    },
    [state.columnDefs, customerHeaderCall]
  );

  const onMenuClicked = (params, event) => {
    // console.log(param, params, "checkcheck");
    const classes = param.attribute_set_key;
    const check = document.querySelector(
      `.${classes} [col-id="${params.column.colId}"]`
    );
    params.showColumnMenu(check);
  };
  const getRowStyle = (params) => {
    // const data = { ...params.data };
    // return data.replied === "no"
    //   ? { background: "rgb(33 150 243 / 11%)" }
    //   : { background: "#fff" };
  };
  const viewTodoHandler = (params) => {
    props.getTodoViewCanvas(params);
  };
  useEffect(() => {
    const formatingcolumns = formatColumn(props.columnDefs || []);
    if (props.columnDefs.length > 0) {
      setState((prevState) => {
        return {
          ...prevState,
          defaultColDef: {
            ...prevState.defaultColDef,
            headerComponent: (params) => customerHeaderCall(params),
          },
          columnDefs: [
            props.attribute_set_type != 4
              ? {
                  headerName: "",
                  maxWidth: 55,
                  editable: false,
                  headerCheckboxSelectionFilteredOnly: true,
                  checkboxSelection: true,
                  headerCheckboxSelection: true,
                  resizable: false,
                  suppressMovable: true,
                  lockPosition: "left",
                  cellClass: "locked-col",
                  lockPinned: true,
                  headerComponent: (params) => checkBoxHeader(params),
                }
              : null,
            (!props.child || props?.showIds) && props.attribute_set_type !== 4
              ? {
                  headerName: "ID",
                  attribute_type: "customer_tattle_uuid",
                  field: "customer_tattle_uuid",
                  maxWidth: 85,
                  editable: false,
                  is_filter: true,
                  sortable: true,
                  filter: CustomFilter,
                  filterParams: {
                    filter: props.getFilterParams,
                    resetFil: props.resetFilter,
                  },
                }
              : props.child && {
                  headerName: "Sl No",
                  field: "sequence",
                  cellRenderer: MainCellRenderer,
                  maxWidth: 80,
                  sortable: true,
                },
            ...formatingcolumns,
            ...(props?.child
              ? [
                  {
                    headerName: "Action",
                    field: "action",
                    cellRenderer: (params) => {
                      return (
                        <div className="action-child">
                          <span
                            className="me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              params.childFunc(
                                params,
                                params.data.customer_tattle_uuid
                              )
                            }
                          >
                            <svg
                              width="17"
                              height="17"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke="#5C5F62"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                          </span>
                          <span
                            className="me-2"
                            onClick={() => props.editHandlerEr(params)}
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              width="17"
                              height="17"
                              viewBox="0 0 17 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.5835 2.25053C11.7586 2.07543 11.9665 1.93654 12.1952 1.84178C12.424 1.74702 12.6692 1.69824 12.9168 1.69824C13.1645 1.69824 13.4097 1.74702 13.6384 1.84178C13.8672 1.93654 14.0751 2.07543 14.2502 2.25053C14.4253 2.42562 14.5642 2.63349 14.6589 2.86227C14.7537 3.09104 14.8024 3.33624 14.8024 3.58386C14.8024 3.83148 14.7537 4.07668 14.6589 4.30545C14.5642 4.53423 14.4253 4.7421 14.2502 4.91719L5.25016 13.9172L1.5835 14.9172L2.5835 11.2505L11.5835 2.25053Z"
                                stroke="#5C5F62"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </span>
                          <span
                            onClick={() =>
                              props.deleteChild(
                                params.data.customer_tattle_uuid
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 4H3.33333H14"
                                stroke="#5C5F62"
                                strokeWidth="1.33"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M5.33301 3.99992V2.66659C5.33301 2.31296 5.47348 1.97382 5.72353 1.72378C5.97358 1.47373 6.31272 1.33325 6.66634 1.33325H9.33301C9.68663 1.33325 10.0258 1.47373 10.2758 1.72378C10.5259 1.97382 10.6663 2.31296 10.6663 2.66659V3.99992M12.6663 3.99992V13.3333C12.6663 13.6869 12.5259 14.026 12.2758 14.2761C12.0258 14.5261 11.6866 14.6666 11.333 14.6666H4.66634C4.31272 14.6666 3.97358 14.5261 3.72353 14.2761C3.47348 14.026 3.33301 13.6869 3.33301 13.3333V3.99992H12.6663Z"
                                stroke="#5C5F62"
                                strokeWidth="1.33"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M6.66699 7.33325V11.3333"
                                stroke="#5C5F62"
                                strokeWidth="1.33"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M9.33301 7.33325V11.3333"
                                stroke="#5C5F62"
                                strokeWidth="1.33"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </span>
                        </div>
                      );
                    },
                  },
                ]
              : ""),
            props.attribute_set_type === 4
              ? {
                  headerName: "Action",
                  field: "action",
                  maxWidth: 100,
                  editable: false,
                  cellRenderer: (params) => {
                    return (
                      <div class="action-child">
                        <span
                          class="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => viewTodoHandler(params)}
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.5835 2.25053C11.7586 2.07543 11.9665 1.93654 12.1952 1.84178C12.424 1.74702 12.6692 1.69824 12.9168 1.69824C13.1645 1.69824 13.4097 1.74702 13.6384 1.84178C13.8672 1.93654 14.0751 2.07543 14.2502 2.25053C14.4253 2.42562 14.5642 2.63349 14.6589 2.86227C14.7537 3.09104 14.8024 3.33624 14.8024 3.58386C14.8024 3.83148 14.7537 4.07668 14.6589 4.30545C14.5642 4.53423 14.4253 4.7421 14.2502 4.91719L5.25016 13.9172L1.5835 14.9172L2.5835 11.2505L11.5835 2.25053Z"
                              stroke="#5C5F62"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </span>
                        <span
                          onClick={() =>
                            props.openNoteHandler(
                              params.data.customer_tattle_uuid
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-6 h-6 me-2"
                            width={17}
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
                            />
                          </svg>
                        </span>
                      </div>
                    );
                  },
                }
              : null,
          ].filter((item) => item !== null && item !== false),
        };
      });
    }
  }, [
    props.columnDefs,
    props.is_admin,
    props.attribute_set_type,
    state.params,
    state.users,
    props.filterName,
    props.resetFilter,
    gridRef,
  ]);
  const checkBoxHeader = (params) => {
    return (
      <input
        className="ag-checkbox-input"
        style={{ height: 16, width: 16, marginLeft: 6 }}
        type="checkbox"
        tabIndex="-1"
        onClick={(evt) => props.selectAllRowHandler(evt, params)}
        ref={headerCheckbox}
      />
    );
  };
  useEffect(() => {
    const cehckboxref = headerCheckbox.current;
    if (cehckboxref) {
      cehckboxref.checked = false;
    }
  }, [props.bulkUpdateDone]);
  useEffect(() => {
    if (!state.checkFunctionCalled) {
      state.columnDefs.forEach((item) => {
        props.gridApi?.api?.destroyFilter(item.field);
      });
    }
  }, [
    props.isReset,
    state.columnDefs,
    props.attribute_set_type,
    state.checkFunctionCalled,
    props.resetFilter
  ]);

  const isEditableCheck = (item) => {
    return item.is_editable || props.is_admin == 1 || false;
  };
  const formatColumn = useCallback(
    (column) => {
      let columnsData = [];
      column.forEach((item) => {
        if (item.attribute_type === "status") {
          let itemnew = {
            ...item,
            cellEditor: StatusCellEditor,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellEditorParams: {
              cellRenderer: function (params) {
                if (params?.value?.name) {
                  return params?.value?.name;
                } else {
                  if (item.options) {
                    if (Array.isArray(params.value)) {
                      return item.options.find(
                        (itt) => (itt._id || itt.id) === params.value[0]
                      )?.name;
                    } else {
                      return item.options.find(
                        (itt) => (itt._id || itt.id) === params.value
                      )?.name;
                    }
                  } else {
                    return params?.value?.name;
                  }
                }
              },
              values: item.options,
            },
            cellRenderer: StatusCellRenderer,
            menuTabs: ["filterMenuTab"],
          };

          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              ref: gridRef,
              className: props.child && "children",
            },
          });
        } else if (
          item.attribute_type.includes(
            "text" || "textarea" || "customer_tattle_uuid"
          )
        ) {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            tooltipComponent: () => {},
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filterName:props.filterName,
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              clearFilter: false,
            },
            filterKey: props.filterName 
          });
        } else if (item.attribute_type === "cc") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              clearFilter: false,
            },
          });
        } else if (
          item.attribute_type === "checkbox" &&
          item.field === "completed"
        ) {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: (params) => {
              return (
                <>
                  <input
                    type="checkbox"
                    value={params.value}
                    id={params.data.customer_tattle_uuid}
                    className="todocheck"
                    name={item.field}
                    onClick={(evt) => checkIsCompleteHandler(evt, params)}
                    checked={
                      params.data.completed == "true" ||
                      params.data.completed == true
                        ? true
                        : false
                    }
                  />
                  <label for={params.data.customer_tattle_uuid}></label>
                </>
              );
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "account_manager") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: MainCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "tse_owner") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: MainCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "sales_manager") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: MainCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "url") {
          const { options } = item;
          let itemnew = {
            ...item,
            cellEditor: UrlEditorParams,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: MainCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "customer_type") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: CustomerCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "company_name") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: CustomerCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "name") {
          const { options } = item;
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: CustomerCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "customer") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: CustomerCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "number") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: (dat) => {
              return dat.value || "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "timestamp") {
          let itemnew = {
            ...item,
            editable: false,
            menuTabs: ["filterMenuTab"],
            editable: isEditableCheck(item),
            cellRenderer: (param) =>
              param.value ? <DateTimeDisplay dateTime={param.value} /> : "",
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "category") {
          let itemnew = {
            ...item,
            cellEditor: CategoryCellEditor,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: CategoryCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "multi-select") {
          let itemnew = {
            ...item,
            cellEditor: SelectCellEditor,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellRenderer: MultiSelectCellRenderer,
            cellEditorParams: {
              isMulti: true,
              cellRenderer: function (params) {
                if (params?.value?.option_name) {
                  return params?.value?.option_name;
                } else {
                  if (item.options) {
                    if (Array.isArray(params.value)) {
                      return item.options.find(
                        (itt) => (itt._id || itt.id) === params.value[0]
                      )?.option_name;
                    } else {
                      return item.options.find(
                        (itt) => itt._id === params.value
                      )?.option_name;
                    }
                  } else {
                    return params?.value?.option_name;
                  }
                }
              },
              values: item.options,
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "date") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditorPopup: true,
            menuTabs: ["filterMenuTab"],
            filter: "agDateColumnFilter",
            cellEditor: DateCellrenderer,
            cellRenderer: (params) => {
              if (
                params.data.completed == true ||
                params.data.completed == "true"
              ) {
                return (
                  <span className="strike-out">
                    {params?.value &&
                    params?.value != "0000-00-00" &&
                    params?.value !== "undefined"
                      ? moment(params?.value).format(
                          process.env.REACT_APP_DATE_FORMAT
                        )
                      : ""}
                  </span>
                );
              }
              return params?.value && params?.value != "0000-00-00"
                ? moment(params?.value).format(
                    process.env.REACT_APP_DATE_FORMAT
                  )
                : "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "start_date") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditorPopup: true,
            menuTabs: ["filterMenuTab"],
            filter: "agDateColumnFilter",
            cellEditor: DateCellrenderer,
            cellRenderer: (params) => {
              return params?.value &&
                params?.value != "0000-00-00" &&
                params?.value != "undefined"
                ? moment(params?.value).format(
                    process.env.REACT_APP_DATE_FORMAT
                  )
                : "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "end_date") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditorPopup: true,
            menuTabs: ["filterMenuTab"],
            filter: "agDateColumnFilter",
            cellEditor: DateCellrenderer,
            cellRenderer: (params) => {
              return params?.value &&
                params?.value != "0000-00-00" &&
                params?.value != "undefined"
                ? moment(params?.value).format(
                    process.env.REACT_APP_DATE_FORMAT
                  )
                : "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "go_live_date") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditorPopup: true,
            menuTabs: ["filterMenuTab"],
            filter: "agDateColumnFilter",
            cellEditor: DateCellrenderer,
            cellRenderer: (params) => {
              return params?.value && params?.value != "0000-00-00"
                ? moment(params?.value).format(
                    process.env.REACT_APP_DATE_FORMAT
                  )
                : "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (
          item.attribute_type === "project" ||
          item.attribute_type == "external_api"
        ) {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellRenderer: ProjectCellRenderer,
            editable: false,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            menuTabs: ["filterMenuTab"],
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "age") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            editable: false,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              className: props.child && "children",
            },
          });
        } else if (item.attribute_type === "last_update_since") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            editable: false,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (item.attribute_type === "board") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            editable: false,
            menuTabs: ["filterMenuTab"],
            cellRenderer: BoardCellRenderer,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              attributeset: props.attribute_set_type,
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              clearFilter: false,
            },
          });
        } else if (
          item.attribute_type === "api" ||
          item.attribute_type === "release"
        ) {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: ApiCellEditor,
            menuTabs: ["filterMenuTab"],
            cellRenderer: ApiCellRenderer,

            cellEditorParams: {
              cellRenderer: function (params) {
                try {
                  if (params?.value?.value) {
                    return params.value.value;
                  } else {
                    if (item.options) {
                      return item.options.find((it) => it.id === params.value)
                        ?.value;
                    } else {
                      return params.value;
                    }
                  }
                } catch (error) {
                  console.log(error);
                }
              },
              values: item.options,
            },
            keyCreator: props.groupByKeyCreater,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              className: props.child && "children",
            },
          });
        } else if (item.attribute_type === "product") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: ApiCellEditor,
            menuTabs: ["filterMenuTab"],
            cellRenderer: CustomerCellRenderer,

            keyCreator: props.groupByKeyCreater,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              className: props.child && "children",
            },
          });
        } else if (item.attribute_type == "effort") {
          let itemnew = {
            ...item,
            menuTabs: ["filterMenuTab"],
            cellEditor: EffortCellEditor,
            editable: isEditableCheck(item),
            cellRenderer: EffortCellRenderer,
            // cellEditorParams: {
            //   cellRenderer: function (params) {
            //     if (params?.value?.option_name) {
            //       return params?.value?.option_name;
            //     } else {
            //       if (item.options) {
            //         if (Array.isArray(params.value)) {
            //           return item.options.find(
            //             (itt) => itt._id === params.value[0]
            //           )?.option_name;
            //         } else {
            //           return item.options.find(
            //             (itt) => itt._id === params.value
            //           )?.option_name;
            //         }
            //       } else {
            //         return params?.value?.option_name;
            //       }
            //     }
            //   },
            //   values: item.options,
            // },
            popupPosition: "under",
            //keyCreator: this.groupByKeyCreater,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else if (
          item.attribute_type === "select" ||
          item.attribute_type === "radio"
        ) {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: SelectCellEditor,
            menuTabs: ["filterMenuTab"],
            cellRenderer: SelectCellRenderer,
            cellEditorParams: {
              cellRenderer: function (params) {
                if (params?.value?.option_name) {
                  return params?.value?.option_name;
                } else {
                  if (item.options) {
                    if (Array.isArray(params.value)) {
                      return item.options.find(
                        (itt) => (itt._id || itt.id) === params.value[0]
                      )?.option_name;
                    } else {
                      return item.options.find(
                        (itt) => (itt._id || itt.id) === params.value
                      )?.option_name;
                    }
                  } else {
                    return params?.value?.option_name;
                  }
                }
              },
              values: item.options,
            },
            popupPosition: "under",
            //keyCreator: this.groupByKeyCreater,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              className: props.child && "children",
            },
          });
        } else if (item.attribute_type === "priority") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: PriorityEditor,
            menuTabs: ["filterMenuTab"],
            cellRenderer: PriorityCellRenderer,
            cellEditorParams: {
              cellRenderer: function (params) {
                if (params?.value?.option_name) {
                  return params?.value?.option_name;
                } else {
                  if (item.options) {
                    if (Array.isArray(params.value)) {
                      return item.options.find(
                        (itt) => itt._id === params.value[0]
                      )?.option_name;
                    } else {
                      return item.options.find(
                        (itt) => itt._id === params.value
                      )?.option_name;
                    }
                  } else {
                    return params?.value?.option_name;
                  }
                }
              },
              values: item.options,
            },

            popupPosition: "under",
            //keyCreator: this.groupByKeyCreater,
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              attributeset: props.attribute_set_type,
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              className: props.child && "children",
            },
          });
        } else if (
          item.attribute_type === "assign_to" ||
          item.attribute_type === "reporter" ||
          item.attribute_type === "people"
        ) {
          const optionsnew = [];
          if (item.options) {
            for (let ii in state.users) {
              optionsnew.push({
                id: state.users[ii].user_uuid,
                name: state.users[ii].name,
                profile_pic: state.users[ii].profile_image,
              });
            }
          }
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: AssignToEdit,
            menuTabs: ["filterMenuTab"],
            cellRenderer: PeopleCellRenderer,
            cellRendererParams: { users: state.users },
            cellEditorParams: {
              users: state.users,
              cellHeight: 35,
              values: optionsnew,
              cellRenderer: function (params) {
                if (state.users) {
                  if (params.value?.name) {
                    return params.value?.name;
                  } else {
                    return state.users[params.value]?.name;
                  }
                } else {
                  return params?.value?.name;
                }
              },
            },
            popupPosition: "under",
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              attributeset: props.attribute_set_type,
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              users: state.users,
              className: props.child && "children",
            },
          });
        } else if (item.attribute_type === "monitoring") {
          let itemnew = {
            ...item,
            cellEditor: AssignToEdit,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            // cellRenderer: PeopleCellRenderer,
            // cellRendererParams: { users: state.users },
            cellRenderer: (param) => {
              if (param.value) {
                return param.value.map(
                  (item) =>
                    state.users[item]?.profile_image && (
                      <OverlayTrigger
                        key={item}
                        placement="top"
                        overlay={
                          <Tooltip id={item}>
                            <strong>
                              {state.users[item]?.name?.charAt(0).toUpperCase()}
                              {state.users[item]?.name?.slice(1)}
                            </strong>
                          </Tooltip>
                        }
                      >
                        <img
                          src={`${state.users[item]?.profile_image}`}
                          className="mo-image"
                        />
                      </OverlayTrigger>
                    )
                );
              }
            },
            popupPosition: "under",
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              attributeset: props.attribute_set_type,
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
              users: state.users,
            },
          });
        } else if (item.attribute_type === "checkbox") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            cellEditor: "agRichSelectCellEditor",
            cellRenderer: CheckboxCellRenderer,
            cellEditorParams: {
              values: [true, false],
            },
          };
          columnsData.push(itemnew);
        } else if (item.attribute_type === "toggle") {
          let itemnew = {
            ...item,
            editable: isEditableCheck(item),
            menuTabs: ["filterMenuTab"],
            cellEditor: ToggleCellEditor,
            cellEditorParams: {
              values: [true, false],
            },
            cellRenderer: (param) => {
              return param?.hasOwnProperty("value")
                ? param?.value === "true" || param?.value === true || param?.value === 1
                  ? `${param?.column?.colDef?.field === "tattle_status" ? "Active" : "Yes"}`
                  : `${param?.column?.colDef?.field === "tattle_status" ? "Inactive" : "No"}`
                : "";
            },
          };
          columnsData.push({
            ...itemnew,
            filter: CustomFilter,
            filterParams: {
              filter: props.getFilterParams,
              resetFil: props.resetFilter,
            },
          });
        } else {
          item = {
            ...item,
            editable: isEditableCheck(item),
          };
          columnsData.push(item);
        }
      });
      return columnsData;
    },
    [statedata.attributes.columns, state.users, props.resetFilter]
  );

  const handleProcessCellForClipboard = (params) => {
    const { colDef } = params?.column;
    const type = colDef?.attribute_type;
    const value = params.value;
  
    switch (type) {
      case "assign_to":
      case "reporter":
      case "people":
        return Array.isArray(value)
          ? value.map((id) => state.users[id]?.name).join(", ")
          : state.users[value]?.name;
  
      case "monitoring":
        return Array.isArray(value)
          ? value.map((item) => state.users[item]?.name).join(", ")
          : state.users[value]?.name;
  
      case "tse_owner":
      case "account_manager":
      case "sales_manager": {
        const { options } = colDef;
        const findValue = (val) =>
          options?.data?.find((item) => (item._id || item.id || item?.user_uuid) === val);
        
        return Array.isArray(value)
          ? value.map((val) => findValue(val)?.option_name || findValue(val)?.name || findValue(val)?.value).join(", ")
          : findValue(value)?.option_name || findValue(value)?.name || findValue(value)?.value;
      }
  
      case "priority":
      case "category":
      case "status":
      case "api":
      case "release":
      case "select":
      case "product": {
        const { options } = colDef;
  
        const findValue = (val) =>
          options?.find((item) => (item._id || item.id) == val);
  
        return Array.isArray(value)
          ? value.map((val) => findValue(val)?.option_name || findValue(val)?.name || findValue(val)?.value).join(", ")
          : findValue(value)?.option_name || findValue(value)?.name || findValue(value)?.value;
      }
  
      case "effort":
        let day = value?.effort_in_days;
        let hour = value?.effort_in_hours;
        let effort = "";
  
        if (day) {
          effort += day > -10 && day < 10 ? `0${day}D ` : `${day}D `;
        }
        if (hour) {
          effort += hour > -10 && hour < 10 ? `0${hour}H` : `${hour}H`;
        }
  
        return effort.trim();
  
      case "customer_type": {
        return params?.node?.data?.customers?.[params.column.colId];
      }
  
      case "timestamp":
        return convertTime(value);
  
      default:
        return Array.isArray(value) ? value.join(", ") : value;
    }
  };
  

  return (
    <>
      <AgGridReact
        sideBar={props.sideBar}
        style={{ width: "100%", height: "100%" }}
        className={props.className}
        suppressKeyboardEvent={(params) => {
          if (params.event.key === "Backspace") {
            return true;
          }
        }}
        key={props.key}
        // enableCellTextSelection={true}
        suppressPaginationPanel={true}
        onFirstDataRendered={props.onFirstDataRendered}
        groupSelectsChildren={props.is_admin == 1 ? true : false}
        groupRemoveSingleChildren={true}
        suppressEnterpriseResetOnNewColumns={true}
        rowSelection={props.rowSelection}
        deltaRowDataMode={true}
        rowMultiSelectWithClick={props.is_admin == 1 ? true : false}
        getRowHeight={20}
        getRowClass={props.getRowClass}
        enableServerSideSorting={props.is_admin == 1 ? true : false}
        paginationPageSize={props.perPageSizeChange}
        onRowSelected={props.onRowSelected}
        onColumnMoved={props.onColumnMoved}
        purgeServerSideCache={true}
        // suppressMovableColumns={props.is_admin != 1 && true}
        suppressMovableColumns={false}
        columnDefs={state.columnDefs}
        suppressRowClickSelection={true}
        onCellValueChanged={props.onCellValueChanged}
        defaultColDef={state.defaultColDef}
        pagination={true}
        getRowStyle={getRowStyle}
        enableColResize={false}
        blockLoadDebounceMillis={100}
        cacheBlockSize={props.cacheBlockSize}
        onGridReady={props.onGridReady}
        maxBlocksInCache={props.maxBlocksInCache}
        statusBar={state.statusBar}
        onColumnResized={props.columnResize && props.onColumnResized}
        // suppressClickEdit={
        //   (!props.suppressClickEdit && props.is_admin == 1) ||
        //   props.attribute_set_type == 4
        //     ? false
        //     : true
        // }
        stopEditingWhenGridLosesFocus={true}
        rowModelType="serverSide"
        suppressContextMenu={true}
        enableServerSideFilter={true}
        serverSideStoreType="ServerSideStoreType[full, partial]"
        overlayLoadingTemplate={
          '<span className="ag-overlay-loading-center">Loading...</span>'
        }
        overlayNoRowsTemplate={
          '<span className="ag-overlay-loading-center">No data found.</span>'
        }
        enableRangeSelection={props.enableRangeSelection}
        enableClipboard={true}
        copyHeadersToClipboard={true}
        processCellForClipboard={handleProcessCellForClipboard}
      />
    </>
  );
};

export default React.memo(AgGridComponent);
